export const accountOwnerDefaultOption = 'All users from the account';
export const teamManagerDefaultOption = 'All my teams';
export const removeOption = 'Remove Teams';
export const noTeamOption = 'no-team';
